// extracted by mini-css-extract-plugin
export var gif = "_em-0";